import TreeViewModel from "../models/TreeviewModel";
import Logger from "../Logger";
import BaseModel from "../models/BaseModel";
import Area from "../models/Area";
import Line from "../models/Line";
import { showErrToast } from "../components/Toasts";
import { itx } from "../translationItx/itx";
import { faAdd } from "@fortawesome/free-solid-svg-icons";

const logger = new Logger();

export default class AreaTreeViewModel extends TreeViewModel {
  get typedObj(): Area {
    return this.obj as Area;
  }

  get isFolder(): boolean {
    return true;
  }
  handleAdd() {
    try {
      const nextLineNumber = this.typedObj.getNextLineNumber();
      if (nextLineNumber < 0) {
        logger.log("No free line number available for this area");
        showErrToast(
          itx("areaTreeViewModel.noFreeLineNumber", "Keine freie Liniennummer für diesen Bereich verfügbar"),
        );
        return;
      }

      const newLine = new Line({}, this.typedObj);
      // new line needes new lineNumber
      newLine.lineNumber = nextLineNumber;
      newLine.tag = `${newLine.lineNumber}`;
      newLine.createdByUser = true;

      this.typedObj.lines.add(newLine);
      this.typedObj.raiseOnChange("childCollection");
      state.selectionManager.selectedObject = newLine;
    } catch (ex) {
      console.error(ex);
    }
  }

  get iconUrl(): string | undefined {
    return "las la-grip-horizontal TopologyLevel1";
  }

  getTagNeeded(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    return this.typedObj.getLines();
  }

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      items: [
        this.baseContextMenuItems_Paste(subLabelPaste),
        this.baseContextMenuItems_Copy(),
        this.baseContextMenuItems_Delete(),
        this.baseContextMenuItems_Add("areaTreeViewModel.addLine"), // no itx
      ],
    };
  }

  getButtons(): JSX.Element[] | undefined {
    return [super.inlineButton_Open("homePane.openAreaProperty"), super.inlineButton_Add("areaTreeViewModel.addLine")]; // no itx
  }
}
